module.exports = __webpack_public_path__ + "img/ScatteredClouds.7eda992a.png";